import { MagicTokenRequestTargetEnum } from "./api/public";

// Canonical environment flags for cnb-web.
//
// `isDev` tracks whether we're running under `yarn start` (create-react-app
// sets NODE_ENV=development in that mode). It's intentionally distinct from
// `useDemoApi` below: you can run `yarn start` against a local API server
// without the demo layer, and you can (in principle) exercise the demo layer
// from a production build for offline demos. Don't conflate them.
const isProd = process.env.NODE_ENV === "production";

// When `REACT_APP_USE_DEMO_API` is "true", every feature hook swaps its real
// API client for an in-memory demo implementation. This was historically tied
// to NODE_ENV, which meant every `yarn start` silently bypassed the real
// backend — a trap that cost people hours on their first OAuth2 test. The
// default is now `false`, so a fresh `yarn start` hits the configured
// REACT_APP_API_URL. Set REACT_APP_USE_DEMO_API=true in .env only if you
// want the offline demo layer.
const useDemoApi = process.env.REACT_APP_USE_DEMO_API === "true";

const sentryEnv = (
  process.env.REACT_APP_SENTRY_ENVIRONMENT || ""
).toLowerCase();

const getEnvName = () =>
  sentryEnv === "local"
    ? "local"
    : sentryEnv === "development"
      ? "development"
      : "production";

const getMagicTokenEnv =
  getEnvName() === "local"
    ? MagicTokenRequestTargetEnum.WebAppLocal
    : getEnvName() === "development"
      ? MagicTokenRequestTargetEnum.WebAppDev
      : MagicTokenRequestTargetEnum.WebApp;

export { isProd, useDemoApi, getEnvName, getMagicTokenEnv };
